<script>
import {defineComponent} from 'vue'
import {useCatalogStore} from '@js/store/CatalogStore.js'
import IconX from "@js/components/Icons/IconX.vue"
import HorizontalDragScroll from "@js/components/HorizontalDragScroll.vue";

export default defineComponent({
    name: "CatalogCategoryNav",

    components: {
        HorizontalDragScroll,
        IconX,
    },

    computed: {
        items() {
            return this.catalogStore.filter_data.categories || []
        },
    },

    methods: {
        isSelected(item) {
            return this.catalogStore.selected_categories.includes(item?.slug)
        },

        toggle(item) {
            if (!item?.slug) return
            this.catalogStore.toggleCategory(item.slug)
        },

        getItemKey(item, index) {
            return item?.slug || item?.title || index
        },
    },

    setup() {
        const catalogStore = useCatalogStore()
        return {catalogStore}
    },
})
</script>

<template>
    <div v-if="items.length" class="w-full max-md:-mt-2 pt-2 md:pt-5 select-none">
        <HorizontalDragScroll :scroll-step="280">
            <div class="inline-flex items-center gap-3 py-1 px-0.5">
                <button
                    v-for="(item, index) in items"
                    :key="getItemKey(item, index)"
                    type="button"
                    @click.prevent="toggle(item)"
                    :class="[
                        isSelected(item)
                            ? 'border-baseColor bg-baseColor/10'
                            : 'border-gray-300 md:hover:border-baseColor'
                    ]"
                    class="group relative inline-flex shrink-0 items-center px-5 py-2.5 border rounded-lg whitespace-nowrap text-sm font-medium transition"
                >
                    {{ item.title }}

                    <span
                        v-if="isSelected(item)"
                        class="absolute -top-1 -right-1 border border-baseColor md:group-hover:border-black bg-baseColor rounded-full p-0.5 transition"
                    >
                        <IconX class="w-3 h-3 stroke-black"/>
                    </span>
                </button>
            </div>
        </HorizontalDragScroll>
    </div>
</template>
